import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import Heander from "../HeaderPortalVendedor";
import Swal from "sweetalert2";
import MenuPrinc from "../../Componentes/MenuPrinc";
import { Container, HomeFornada } from "./styles";
import {
  MDBRow,
  MDBCol,
  MDBBtn,
  MDBDataTable,
  MDBModal,
  MDBModalBody,
  MDBModalFooter,
  MDBModalHeader,
} from "mdbreact";

// import "react-datepicker/dist/react-datepicker.css";
import Carregando from "../../Componentes/Carregando";
import ReactExport from "react-data-export";
import { URLBunge } from "../../Componentes/Config";
const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

var dataTable = {
  columns: [
    {
      label: "Data",
      field: "data",
      sort: "asc",
      width: 100,
    },
    {
      label: "Status",
      field: "status",
      sort: "asc",
      width: 100,
    },
    {
      label: "Nome",
      field: "nome",
      sort: "asc",
      width: 100,
    },
    {
      label: "Cliente Bunge",
      field: "cliente",
      sort: "asc",
      width: 100,
    },
    {
      label: "CPF",
      field: "cpf",
      sort: "asc",
      width: 100,
    },
    {
      label: "Email",
      field: "email",
      sort: "asc",
      width: 100,
    },
    {
      label: "CNPJ",
      field: "cnpj",
      sort: "asc",
      width: 100,
    },
    {
      label: "Razão Social",
      field: "razaoSocial",
      sort: "asc",
      width: 100,
    },
    {
      label: "Nome Fantasia",
      field: "nomeFantasia",
      sort: "asc",
      width: 100,
    },
    {
      label: "Celular",
      field: "numeroTel",
      sort: "asc",
      width: 100,
    },
    {
      label: "Tel Fixo",
      field: "fixo",
      sort: "asc",
      width: 100,
    },
    {
      label: "Resposta",
      field: "resp",
      sort: "asc",
      width: 100,
    },
    {
      label: "Status",
      field: "btStatus",
      sort: "asc",
      width: 100,
    },
  ],
  rows: [],
};

const TOKEN = localStorage.getItem("c_token");
const EMAIL_USUARIO = localStorage.getItem("c_email");
class Home extends Component {
  state = {
    att: false,
    departamento: "",
    questionTable: [],
    questionRespostas: [],
    cpf: "",
    id: null,
    status: 1,
    motivo: "",
    idQuestionario: 0,
    loading: false,
  };

  async componentDidMount() {
    var myHeaders = new Headers();
    myHeaders.append("Authorization", "bearer " + TOKEN);
    myHeaders.append("Content-Type", "application/json");
    var requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };
    var departamento = await fetch(
      `${URLBunge}/api/AdminVendedor/DadosUser/${2329681}/${EMAIL_USUARIO}`,
      requestOptions
    ).then((response) => response.json());
    if (departamento.sucesso === false) {
      this.setState({ departamento: departamento.mensagem });
    }
    this.carregaQuestionario();
  }

  carregaQuestionario = async (busca) => {
    this.setState({ loading: true });
    var myHeaders = new Headers();
    myHeaders.append("Authorization", "bearer " + TOKEN);
    myHeaders.append("Content-Type", "application/json");
    var requestOptions = {
      method: "GET",
      headers: myHeaders,
      body: JSON.stringify(busca),
      redirect: "follow",
    };
    var Question = await fetch(
      `${URLBunge}/api/Formulario/Listar/${2329681}`,
      requestOptions
    )
      .then((response) => response.json())
      .catch((error) => this.setState({ loading: false }));

    //return;
    if (Question && Question.sucesso) {
      let questionTable = dataTable;

      questionTable.rows = [];
      Question.dadoCadastro.forEach((ques) => {
        let status = ques.status;
        if (status === null) {
          status = " - ";
        } else if (status === 0) {
          status = "Rejeitado";
        } else {
          status = "Aceito";
        }

        let questionNovo = {
          data: ques.dataCadastro === null ? " - " : ques.dataCadastro,
          nome: ques.nome,
          cliente: ques.clienteBunge === 1 ? "Sim" : "Não",
          cpf: ques.cpf,
          email: ques.email,
          cnpj: ques.cnpj,
          razaoSocial: ques.razaoSocial,
          nomeFantasia: ques.nomeFantasia,
          numeroTel: "(" + ques.dddCel + ")" + ques.numeroCel,
          fixo: "(" + ques.dddTel + ")" + ques.numeroTel,
          status: status,
          resp: (
            <MDBBtn color="blue" size="sm" onClick={() => this.toggle(4, ques)}>
              {" "}
              Consultar{" "}
            </MDBBtn>
          ),
          btStatus: (
            <MDBBtn
              color="green"
              size="sm"
              onClick={() => this.toggleStatus(1, ques)}
            >
              {" "}
              Alterar{" "}
            </MDBBtn>
          ),
        };
        questionTable.rows.push(questionNovo);
      });

      this.setState({ questionTable });
      //this.setState({questionRespostas: questionTable.respostas});
    }
    this.setState({ loading: false });
  };

  toggle = (nr, respostas) => {
    if (respostas !== null && respostas !== undefined) {
      var resp = respostas;
      this.setState({ cpf: resp.cpf });
      this.setState({ questionRespostas: resp.respostas });
    }

    let modalNumber = "modal" + nr;
    this.setState({
      [modalNumber]: !this.state[modalNumber],
    });
  };

  toggleStatus = (nr, ques) => {
    if (ques !== null && ques !== undefined) {
      this.setState({ status: ques.status === null ? "1" : ques.status });
      this.setState({ motivo: ques.motivo });
      this.setState({ idQuestionario: ques.id });
    }

    let modalNumber = "modal" + nr;
    this.setState({
      [modalNumber]: !this.state[modalNumber],
    });
  };

  AtualizaStatus = async () => {
    this.setState({ loading: true });
    var myHeaders = new Headers();
    myHeaders.append("Authorization", "bearer " + TOKEN);
    myHeaders.append("Content-Type", "application/json");

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: JSON.stringify(dados),
      redirect: "follow",
    };
    let status = this.state.status;
    let motivo = this.state.motivo;

    if (status === "0" && motivo === null) {
      Swal.fire({
        icon: "warning",
        title: "Atenção!",
        text: "Informe o motivo da rejeição",
      });
      return;
    } else if (status === "") {
      Swal.fire({
        icon: "warning",
        title: "Atenção!",
        text: "Informe um status",
      });
    }

    const dados = {
      IdProjeto: 2329681,
      Status: parseInt(status),
      Id: parseInt(this.state.idQuestionario),
      Motivo: motivo === null ? "" : motivo,
    };

    var response = await fetch(
      `${URLBunge}/api/Formulario/AceiteFormulario`,
      requestOptions
    ).then((response) => response.json());
    if (response.data.sucesso) {
      this.setState({ loading: false });
      Swal.fire({
        icon: "success",
        title: "Parabéns!",
        text: "Alterado com sucesso!",
      }).then(function () {
        window.location = "/Questionario";
      });
    } else {
      this.setState({ loading: false });
      Swal.fire({
        icon: "warning",
        title: "Atenção!",
        text: response.data.mensagem,
      });
    }
  };

  render() {
    return (
      <Container>
        <Heander />
        <MenuPrinc />

        {this.state.loading && <Carregando />}
        <HomeFornada>
          <div className="clear"></div>

          <ExcelFile
            element={
              <MDBBtn color="primary" size="sm" style={{ float: "right" }}>
                Exportar em Excel
              </MDBBtn>
            }
          >
            <ExcelSheet data={this.state.questionTable.rows} name="Employees">
              <ExcelColumn label="Nome" value="nome" />
              <ExcelColumn label="CPF" value="cpf" />
              <ExcelColumn label="CLIENTE BUNGE" value="cliente" />
              <ExcelColumn label="EMAIL" value="email" />
              <ExcelColumn label="CNPJ" value="cnpj" />
              <ExcelColumn label="RAZAO" value="razaoSocial" />
              <ExcelColumn label="Tel fixo" value="fixo" />
            </ExcelSheet>
          </ExcelFile>

          <div className="cadastros">
            <h1>Questionários enviados</h1>
            <div class="tabresp">
              <MDBDataTable
                striped
                bordered
                hover
                searchLabel="Pesquisar"
                paginationLabel={["Anterior", "Próximo"]}
                noRecordsFoundLabel="Nenhum resultado encontrado"
                infoLabel={["Mostrando", "de", "até", "registros"]}
                entriesLabel="Qtd por pagina"
                data={this.state.questionTable}
              />
            </div>
          </div>

          {/* CONSULTA */}
          <MDBModal
            isOpen={this.state.modal4}
            toggle={() => this.toggle(4)}
            size="lg"
          >
            <MDBModalHeader toggle={() => this.toggle(4)}>
              RESPOSTAS
            </MDBModalHeader>
            <MDBModalBody>
              <form className="oft">
                <MDBRow>
                  <MDBCol md="12">
                    <MDBRow>
                      <table className="tabela">
                        <tr>
                          <th colspan="3">CPF: {this.state.cpf}</th>
                        </tr>
                        <tr>
                          <th>Pergunta</th>
                          <th>Resposta</th>
                          <th>Outro?</th>
                        </tr>
                        {this.state.questionRespostas.map((res, i) => (
                          <tr key={i}>
                            <td> {res.pergunta}</td>
                            <td>{res.descricaoFormularioTipo}</td>
                            <td>{res.texto}</td>
                          </tr>
                        ))}
                      </table>
                    </MDBRow>
                  </MDBCol>
                </MDBRow>
              </form>
            </MDBModalBody>
            <MDBModalFooter></MDBModalFooter>
          </MDBModal>

          {/* ALTERA STATUS */}
          <MDBModal
            isOpen={this.state.modal1}
            toggle={() => this.toggleStatus(1)}
            size="md"
          >
            <MDBModalHeader toggle={() => this.toggleStatus(1)}>
              Status
            </MDBModalHeader>
            <MDBModalBody>
              <form className="oft">
                <MDBRow>
                  <MDBCol md="12">
                    <MDBRow>
                      {/* Status */}
                      <MDBCol md="6">
                        <label>Status</label>
                        <select
                          name="status"
                          id="status"
                          className="form-control"
                          onChange={(e) => {
                            this.setState({ status: e.target.value });
                          }}
                        >
                          <option
                            value=""
                            selected={
                              this.state.status === "" ? "selected" : ""
                            }
                          >
                            Status
                          </option>
                          <option
                            value={1}
                            selected={this.state.status === 1 ? "selected" : ""}
                          >
                            Aceito
                          </option>
                          <option
                            value={0}
                            selected={this.state.status === 0 ? "selected" : ""}
                          >
                            Rejeitado
                          </option>
                        </select>
                      </MDBCol>

                      {this.state.status === 0 || this.state.status === "0" ? (
                        <>
                          <div className="clear"></div>
                          <br />
                          <MDBCol md="12">
                            <textarea
                              label="motivo"
                              className="form-control"
                              outline
                              placeholder="Motivo da rejeição"
                              size="lg"
                              rows="5"
                              value={this.state.motivo}
                              onChange={(e) => {
                                this.setState({ motivo: e.target.value });
                              }}
                            />
                          </MDBCol>
                        </>
                      ) : (
                        <></>
                      )}
                    </MDBRow>
                  </MDBCol>
                </MDBRow>
              </form>
            </MDBModalBody>
            <MDBModalFooter>
              <MDBBtn
                color="primary"
                size="sm"
                onClick={() => this.AtualizaStatus()}
              >
                Atualizar
              </MDBBtn>
            </MDBModalFooter>
          </MDBModal>
        </HomeFornada>
        {/* <Carregando /> */}
      </Container>
    );
  }
}

export default withRouter(Home);
